import { ContactUsModal } from "@hydra/plugins";
import { PluginRegistry } from "../core/pluginRegistry";
import type { Modal } from "../plugins/modal";

export class HydraUtils {
  static closeAllModals(): number {
    return PluginRegistry.executeMethodOnType<Modal>("modal", "hide");
  }

  static openContactUsModal(): number {
    return PluginRegistry.executeMethodOnType<ContactUsModal>(
      "contact-us-modal",
      "open",
    );
  }
}

declare global {
  interface Window {
    HydraUtils: typeof HydraUtils;
  }
}
